import React from "react";
import "./OpenItemButton.scss";

const OpenItemButton = ({ text }) => {
  return <span className="open-item">{text}</span>;
};
export default OpenItemButton;
